// extracted by mini-css-extract-plugin
export default {"Category":"Category_Category__BzDkX","Category__icon":"Category_Category__icon__v4LIL","Category__text":"Category_Category__text__xmK7m"};